//import {authRoles} from 'auth/auth';

export const fuseNavigationConfig = [
  {
    'id': 'company-component',
    'title': 'Dashboards',
    'type': 'item',
    'icon': 'dashboard',
    'url': '/dashboard'
  },
  {
    'id': 'list-component',
    'title': 'Listing Entities',
    'type': 'item',
    'icon': 'today',
    'url': 'https://crm.dcsx.io/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DDCSX_Companies%26action%3Dindex%26parentTab%3DListing+Entities'
  },
  {
    'id': 'brokers-component',
    'title': 'Brokers',
    'type': 'item',
    'icon': 'local_atm',
    'url': '/brokersettlement'
  },
  {
    'id': 'LAD-component',
    'title': 'Listing Advisors',
    'type': 'item',
    'icon': 'pin_drop',
    'url': 'https://crm.dcsx.io/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DDCSX_ListingAdvisers%26action%3Dindex%26parentTab%3DService+Providers'
  },
  {
    'id': 'Serviceproviders-component',
    'title': 'Service Providers',
    'type': 'item',
    'icon': 'store',
    'url': 'https://crm.dcsx.io/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DDCSX_ServiceProviders%26action%3Dindex%26parentTab%3DService+Providers'
  },

  {
    'id': 'members-component',
    'title': 'Members',
    'type': 'item',
    'icon': 'settings',
    'url': 'https://crm.dcsx.io/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DDCSX_Members%26action%3Dindex%26parentTab%3DService+Providers'
  },
  {
    'id': 'registries-component',
    'title': 'Share Registries',
    'type': 'item',
    'icon': 'account_box',
    'url': 'https://crm.dcsx.io/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DDCSX_Registries%26action%3Dindex%26parentTab%3DService+Providers'
  },
  {
    'id': 'settlement-component',
    'title': 'Settlement',
    'type': 'item',
    'icon': 'account_box',
    'url': '/settlement'
  },
  {
    'id': 'custodian-component',
    'title': 'Custodian',
    'type': 'item',
    'icon': 'account_box',
    'url': '/custodian'
  },
  {
    'id': 'rec-component',
    'title': 'Custodian Rec.',
    'type': 'item',
    'icon': 'account_box',
    'url': '/custodian_certificate_reconciliation'
  },
  {
    'id': 'isin-component',
    'title': 'ISIN',
    'type': 'item',
    'icon': 'account_box',
    'url': '/isin_applications'
  },
  {
    'id': 'fr-component',
    'title': 'File Requests',
    'type': 'item',
    'icon': 'account_box',
    'url': '/file_request'
  },

];



// WEBPACK FOOTER //
// ./src/fuse-configs/fuseNavigationConfig.js